import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { scrollToTop } from '../util/app/app.helpers'

const useScrollTop = () => {
  const location = useLocation()
  useEffect(() => {
    scrollToTop()
  }, [location.pathname])
  return null
}

export { useScrollTop }
